import useAxiosRequest from "../hooks/useAxiosRequest";
import {createContext, useEffect, useState} from "react";
import OverlayDiv from "../components/OverlayDiv";

import '../styles/MapRenderer.css';
import LegendRenderer from "../components/LegendRenderer";

import config from '../config.json';

export const MapContext = createContext(null);

const MapRenderer = ({ id }) => {
    let { data: map, setData: setMap } = useAxiosRequest({
        url: `${config.backendUrl}/maps/${id}`,
        withCredentials: true,
        method: "get"
    });

    let { data: template } = useAxiosRequest({
        url: `${config.backendUrl}/maps/templates/${map?.template}`,
        withCredentials: true,
        method: "get"
    }, [ map ]);

    const [ rendered, setRendered ] = useState(false);

    useEffect(() => {
        if (!map || !template) return;

        Object.entries(map.divisions).forEach(([ division, legendItemId ]) => {
            const legendItem = template.legend.find(item => item.id === legendItemId);

            document.querySelectorAll(`path.division-${division}`).forEach(element => element.style.fill = legendItem.color);
        });

        Object.entries(map.custom ?? {}).forEach(([ division, customData ]) => {
            const components = document.querySelectorAll(`path.division-${division}`);

            components.forEach(component => {
                component.style.fill = customData.fill ?? component.style.fill;
                component.style.fill = customData.fill ?? component.style.fill;
            })
        })
        setRendered(true);
    }, [map, template]);

    if (!map || !template) return;

    return (
        <MapContext.Provider value={{ map, template, setMap }}>
            <div id="MapRenderer">
                <div id="main-content" className={rendered ? 'rendered' : ''} style={{ backgroundColor: map.background ?? '#22252a' }}>
                    <LegendRenderer/>
                    <OverlayDiv showControls={false}>
                        <div id="image-container" dangerouslySetInnerHTML={{__html: atob(template.image)}}/>
                    </OverlayDiv>
                </div>
            </div>
        </MapContext.Provider>
    )
}

export default MapRenderer;
